export default __webpack_public_path__ + "static/media/Principal_Raya2026.63a8bf91.jpg";